import { type InjectionKey, inject, type App } from 'vue'
import type { DeviceApi } from './deviceApi'

class DeviceApiNotProvidedError extends Error {}

export const deviceApiKey = Symbol() as InjectionKey<DeviceApi>

// Must call in Vue component. Provides DeviceApi via `useDeviceApi` in all
// components subtree.
export function provideDeviceApi(app: App, deviceApi: DeviceApi) {
  app.provide(deviceApiKey, deviceApi)
}

// Must call in Vue component. Injects DeviceApi using Vue's DI framework.
// Throws error if DeviceApi was not provided in this component tree.
export function useDeviceApi(): DeviceApi {
  const deviceApi = inject(deviceApiKey)
  if (deviceApi === undefined) {
    throw new DeviceApiNotProvidedError('DeviceApi was not provided in component tree.')
  }

  return deviceApi
}
